module.exports = __webpack_public_path__ + "static/media/preview.50fe625b.png";